export const initialState={
    basket:[],
};
export const getBasketTotal =(basket)=>
basket?.reduce((amount,item)=>item.price+amount,0);
const reducer =(state,action)=>{
    console.log(action);
    switch(action.type){
        case 'ADD_TO_BASKET':
            return {
                ...state,
                basket:[...state.basket,action.item]
            }
           case "REMOVE_FROM_BASKET":
               const index=state.basket.findIndex(
                   (basketItem)=>basketItem.id ===action.id
               )
               let newBasket =[...state.basket]
               if(index>=0){
                   //the splice() method changes the contents of an array by removing or replacing existing elements and/or adding new elements in place
                   newBasket.splice(index,1);

               }else{
                   console.warn("can't remove products");
               }
               return {
                   ...state,
                   basket:newBasket
               }
        default:
            return state;
    }
}
export default reducer